import { Component, Input } from '@angular/core';
import { ModalService } from '../../shared/services/modal.service';

@Component({
  selector: 'md-help-me-decide',
  template: require('./help-me-decide.component.html'),
  styles: [require('./help-me-decide.component.scss')]
})

export class HelpMeDecideComponent {
  @Input() helpMeObj;

  constructor(modal: ModalService) {
    this.modal = modal;
  }

  onLinkModalClick() {
    this.modal.generic(this.helpMeObj.modalContent);
  }

}
